<div [class.full-card]="isFullscreen" [ngStyle]="{'max-height': '100%'}">
  <mat-card [ngClass]="size">
    <mat-card-header class="header-card">
      <mat-card-title class="card-title">{{ title | translate }}</mat-card-title>
      <mat-card-subtitle class="card-subtitle">{{ subtitle | translate }}</mat-card-subtitle>
      <div class="header-card-right">
        <ng-content select="[header-actions]"></ng-content>
        @if (fullscreenEnable && isFullscreen) {
          <span (click)="toggleFullscreen()" class="icon-fullscreen">
            @if (isFullscreen) {
              <i class="fa-solid fa-compress iconreen"></i>
            }
          </span>
        }
        @if (fullscreenEnable && !isFullscreen) {
          <span (click)="toggleFullscreen()" class="icon-fullscreen">
            @if (!isFullscreen) {
              <i class="fa-solid fa-expand"></i>
            }
          </span>
        }
      </div>
    </mat-card-header>

    <mat-card-content>
      <!-- msg -->
      @switch (eventMsg) {
        @case (CARD_EVENT_MSG.ERROR_GET_DATA) {
          <app-msg [msg]="errorGettingData" [type]="'info error'" [hasIcon]="true" [hasBold]="true"></app-msg>
        }
        @case (CARD_EVENT_MSG.SUCCESS_CREATE) {
          <app-msg [msg]="successCreate" [type]="'danger'"></app-msg>
        }
        @case (CARD_EVENT_MSG.SUCCESS_UPDATE) {
          <app-msg [msg]="successUpdate" [type]="'danger'"></app-msg>
        }
        @default {
          @if (hasNoData) {
            <app-msg [msg]="noData" [type]="'info'" [hasBold]="true"></app-msg>
          }
        }
      }

      <!-- content -->
      @if (eventMsg !== CARD_EVENT_MSG.ERROR_GET_DATA && !hasNoData) {
        <ng-content select="[main]"></ng-content>
      }
    </mat-card-content>

    <div class="mat-mdc-card-footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </mat-card>
</div>
